import React from 'react';

const PostDistance = (props) => {
    const {
        distance,
    } = props;

    let unit = 'Mile';

    if(parseInt(distance) > 1) {
        unit = 'Miles';
    }

    let postDistanceTag = <div 
    className='cpt-post-distance'
    dangerouslySetInnerHTML={{__html: distance + ' ' + unit}}/>
    return postDistanceTag;
}

export default PostDistance;